import { FC, useMemo } from 'react'
import { generatePath, Redirect, Route, RouteComponentProps } from 'react-router'
import Roles from '../../models/roles'
import { AUTH_ROUTE } from '../../pages/App/routes'
import { useSelector } from '../../store'

type RouteWithLayoutProps = {
  layout: FC
  component: FC<RouteComponentProps>
  path: string
  exact?: boolean
}

const RouteWithLayout: FC<RouteWithLayoutProps> = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  const { user, currentProject, location } = useSelector((state) => ({
    user: state.auth.user,
    currentProject: state.project.currentProject,
    location: state.router.location
  }))

  const isApprover = useMemo(
    () =>
      user?.agency_role === Roles.EXTERNAL_APPROVER ||
      user?.agency_role === Roles.INTERNAL_APPROVER,
    [user]
  )

  const fromLocation = (location as any).state && (location as any).state.from

  return (
    <Route
      {...rest}
      render={(matchProps: any) => {
        if (!user || user.is_blocked) {
          return (
            <Layout>
              <Component {...matchProps} />
            </Layout>
          )
        } else if (!!currentProject.id && fromLocation) {
          return <Redirect to={fromLocation} />
        } else if (!!currentProject.id) {
          return !isApprover ? (
            <Redirect
              to={generatePath(AUTH_ROUTE.CALENDAR, {
                projectId: currentProject.id
              })}
            />
          ) : (
            <Redirect
              to={generatePath(AUTH_ROUTE.CALENDAR_APPROVAL, {
                projectId: currentProject.id
              })}
            />
          )

        } else {
          return  (user.can_create_agency && !user.card_status) ? (
            <Redirect
              to={generatePath(AUTH_ROUTE.ADD_CARD)}
            />
          ):user.can_create_agency ? (
            <Redirect
              to={generatePath(AUTH_ROUTE.CREATE_AGENCY, {
                step: 1
              })}
            />
          ) : user.can_create_project ? (
            <Redirect
              to={generatePath(AUTH_ROUTE.CREATE_PROJECT, {
                step: 1
              })}
            />
          ) : (
            <Redirect to={{ pathname: AUTH_ROUTE.EMPTY_PROJECTS }} />
          )
        }
      }}
    />
  )
}

export default RouteWithLayout
